<template>
  <div
    v-if="show"
    class="d-flex align-center mb-2"
    :class="outlined ? 'mt-n6' : 'mt-n2'"
    style="color: #1976d2; font-size: 12px;"
  >
    <v-icon small color="#1976d2" class="mr-1">mdi-information</v-icon>
    <span>{{ computedMessage }}</span>
  </div>
</template>

<script>
const MESSAGES = {
  outletSubmerchant: 'Field ini otomatis mengikuti Aggregator karena terdaftar sebagai Outlet Submerchant dan tidak dapat diubah',
  outletMerchant: 'Field ini otomatis mengikuti Merchant utama karena terdaftar sebagai Outlet dan tidak dapat diubah',
  submerchant: 'Field ini otomatis mengikuti Aggregator karena terdaftar sebagai Submerchant dan tidak dapat diubah',
};

export default {
  name: 'FieldInfoHelper',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
      validator: (val) => ['', 'outletSubmerchant', 'outletMerchant', 'submerchant'].includes(val),
    },
    outlined: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedMessage() {
      return MESSAGES[this.type] || '';
    },
  },
};
</script>
